/* unplugin-vue-components disabled */import script from "./TextReader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextReader.vue?vue&type=script&lang=ts&setup=true"

import "./TextReader.vue?vue&type=style&index=0&id=b7f7b32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7f7b32a"]])

export default __exports__